export default __webpack_public_path__ + "354eb930e4eebf71e2f17c55f9160796.png";